
import { useProductData } from './product/useProductData';
import { useProductOperations } from './product/useProductOperations';
import { useProductSelection } from './product/useProductSelection';
import { useProductClicks } from './product/useProductClicks';

export function useProducts() {
  const { 
    products,
    filteredProducts,
    categories,
    loading,
    searchQuery,
    setSearchQuery,
    fetchProducts,
    updateLocalProductState,
    removeProductsFromState
  } = useProductData();

  const {
    isDuplicating,
    selectedProduct,
    isDeleting,
    productToDelete,
    productSourceToDelete,
    duplicateProduct: duplicateProductOp,
    addToProducts: addToProductsOp,
    confirmDelete,
    cancelDelete,
    deleteProduct: deleteProductOp
  } = useProductOperations();

  const {
    isSelectionMode,
    selectedProducts,
    isBulkUpdating,
    toggleSelectionMode,
    selectProduct,
    selectAll,
    clearSelection,
    updateCategoryBulk: updateCategoryBulkOp,
    deleteBulk: deleteBulkOp,
    tagAllProducts: tagAllProductsOp
  } = useProductSelection();

  const { trackProductClick } = useProductClicks();

  // Wrap operations to update local state after API operations
  const duplicateProduct = async (product) => {
    const success = await duplicateProductOp(product);
    if (success) {
      await fetchProducts();
    }
    return success;
  };

  const addToProducts = async (recommendation) => {
    const success = await addToProductsOp(recommendation);
    if (success) {
      await fetchProducts();
    }
    return success;
  };

  const deleteProduct = async () => {
    const success = await deleteProductOp();
    if (success && productToDelete && productSourceToDelete) {
      // We could optimize by removing from local state, but fetching ensures consistency
      await fetchProducts();
    }
    return success;
  };

  const updateCategoryBulk = async (products, newCategory) => {
    const success = await updateCategoryBulkOp(products, newCategory);
    if (success) {
      await fetchProducts();
    }
    return success;
  };

  const deleteBulk = async (products) => {
    const success = await deleteBulkOp(products);
    if (success) {
      await fetchProducts();
    }
    return success;
  };

  const tagAllProducts = async (products, newCategory) => {
    const success = await tagAllProductsOp(products, newCategory);
    if (success) {
      await fetchProducts();
    }
    return success;
  };

  return {
    products,
    filteredProducts,
    categories,
    loading,
    searchQuery,
    setSearchQuery,
    isDuplicating,
    selectedProduct,
    isDeleting,
    productToDelete,
    productSourceToDelete,
    fetchProducts,
    duplicateProduct,
    addToProducts,
    confirmDelete,
    cancelDelete,
    deleteProduct,
    trackProductClick,
    // Bulk operations
    isSelectionMode,
    selectedProducts,
    isBulkUpdating,
    toggleSelectionMode,
    selectProduct,
    selectAll,
    clearSelection,
    updateCategoryBulk,
    deleteBulk,
    tagAllProducts
  };
}
